// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const AlertCircleOutline: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM12 13a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z" />
    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c-.006 5.52-4.48 9.994-9.999 10H12Zm0-18a8 8 0 1 0 8 8 8.01 8.01 0 0 0-8-8Z" />
  </SvgIcon>
);

AlertCircleOutline.activeColor = 'inherit';
AlertCircleOutline.muiName = 'AlertCircleOutline';
